/**
 * Descuentos de Regios Discounts pintados con el diseño de la tienda.
 *
 * Regios publica en cada página su configuración (<script id="regios-dopp-config">), que su
 * embed genera al momento: activar, cambiar o apagar un descuento en la app se refleja en la
 * próxima carga, sin sincronizar nada. Su propia forma de pintar precios no calza con el tema
 * Woodstock (dejaba el precio encimado y sin rebajar), así que está apagada (disable_auto_config)
 * y este script la reemplaza: precio normal tachado, precio final, «Ahorra X%» junto al precio y
 * en la burbuja de la foto, y las cuotas de Venti / Mercado Pago sobre el precio final.
 *
 * Solo entiende las reglas simples de Regios: «si el producto es uno de estos productos o está
 * en estas colecciones → descuento de monto fijo o porcentaje», sin compra mínima, para todos
 * los clientes o para los que tienen ciertas etiquetas (los convenios: conv-…). Lo que no
 * entiende no lo muestra (el descuento igual se cobra en el carro).
 *
 * Los datos de cada precio los pone Liquid en atributos data-regios-* (snippets/price.liquid,
 * card-product-badges.liquid, venti-cuotas.liquid, mercadopago-cuotas.liquid).
 */
(function () {
  "use strict";

  var reglas = null;

  // Etiquetas automáticas en los productos con descuento (CYBER DAYS y las que se creen igual).
  // Ya no se escriben aquí: son metaobjetos «Etiqueta de producto» con «Cuándo se muestra» =
  // «Automática», con sus fechas y colecciones, que publica snippets/etiquetas-auto-config.liquid.
  var autos = null;
  function etiquetasAuto() {
    if (autos) return autos;
    var nodo = document.getElementById("etiquetas-auto-config");
    try { autos = nodo ? JSON.parse(nodo.textContent) : []; } catch (e) { autos = []; }
    return autos;
  }
  // Primera etiqueta automática vigente para el producto (sin producto: solo las que no filtran por colección)
  function campanaPara(prod) {
    var ahora = Date.now();
    return etiquetasAuto().filter(function (a) {
      if (a.desde && ahora < a.desde) return false;
      if (a.hasta && ahora >= a.hasta) return false;
      if (!a.colecciones || !a.colecciones.length) return true;
      return !!prod && prod.colecciones.some(function (c) { return a.colecciones.indexOf(String(c)) > -1; });
    })[0] || null;
  }
  function pintarCampana(span, c) {
    span.textContent = c.texto;
    span.style.background = c.fondo;
    span.style.color = c.letra;
    return span;
  }
  // Descuentos de Regios que duran hasta 26 h llevan la etiqueta «Solo por 24 horas»
  var RELAMPAGO_MAX = 26 * 3600 * 1000;
  function etiquetaRelampago(clase) {
    var e = document.createElement("span");
    e.className = clase;
    e.innerHTML = 'Solo por <span class="relampago__horas">24 horas</span>';
    return e;
  }

  function leerConfig() {
    var nodo = document.getElementById("regios-dopp-config");
    if (!nodo) return [];
    var datos;
    try {
      datos = JSON.parse(nodo.textContent);
    } catch (e) {
      return [];
    }
    var lista = [];
    var configs = datos.discountConfigs || {};
    Object.keys(configs).forEach(function (id) {
      var crudo = configs[id];
      if (!crudo || crudo === "null") return;
      try {
        var d = typeof crudo === "string" ? JSON.parse(crudo) : crudo;
        if (d && d.config) lista.push(d);
      } catch (e) {
        /* descuento ilegible: se ignora */
      }
    });
    return lista;
  }

  function ids(texto, lista) {
    var salida = String(texto || "")
      .split(",")
      .map(function (x) { return x.trim(); })
      .filter(Boolean);
    (lista || []).forEach(function (x) {
      var id = x && (x.id || x);
      if (id) salida.push(String(id).split("/").pop());
    });
    return salida;
  }

  function elegible(eleg, prod) {
    if (!eleg || !eleg.type) return false;
    if (eleg.type === "ALL_PRODUCTS") return true;
    var lista = ids(eleg.asListOfIds, eleg.selectedProducts || eleg.selectedCollections);
    // «Variantes específicas»: Regios las guarda como { idProducto: "idVariante,idVariante" }.
    // En la ficha cuenta la variante elegida (cada una puede tener su descuento); en la tarjeta,
    // que no sabe qué variante mirará el cliente, basta con que alguna variante tenga descuento.
    if (eleg.compactFormat) {
      var variantes = eleg.compactFormat[prod.id];
      if (variantes !== undefined && prod.variante) {
        return String(variantes).split(",").map(function (x) { return x.trim(); }).indexOf(prod.variante) > -1;
      }
      lista = lista.concat(Object.keys(eleg.compactFormat));
    }
    (eleg.selectedProductVariants || []).forEach(function (v) {
      var idp = v && (v.productId || (v.product && v.product.id));
      if (idp) lista.push(String(idp).split("/").pop());
    });
    if (/COLLECTION/.test(eleg.type)) {
      return prod.colecciones.some(function (c) { return lista.indexOf(c) > -1; });
    }
    if (/PRODUCT/.test(eleg.type)) return lista.indexOf(prod.id) > -1;
    return false;
  }

  function valor(v) {
    if (!v) return null;
    if (v.type === "FIXED_AMOUNT" && +v.amount > 0) {
      return { tipo: "monto", valor: +v.amount, unaVez: !!v.onlyApplyDiscountOncePerOrder };
    }
    if (v.type === "PERCENTAGE" && +v.percentage > 0) {
      return { tipo: "porcentaje", valor: +v.percentage, unaVez: false };
    }
    // «Precio fijo»: el producto queda a ese precio (en pesos), sin importar el normal
    if (v.type === "FIXED_PRICE" && v.price !== undefined && v.price !== "" && +v.price >= 0) {
      return { tipo: "precio", valor: +v.price, unaVez: !!v.onlyApplyDiscountOncePerOrder };
    }
    return null;
  }

  // Etiquetas del cliente con sesión iniciada (layout/theme.liquid, #em-cliente-config). Sin sesión: [].
  var etiquetas = null;
  function etiquetasCliente() {
    if (etiquetas) return etiquetas;
    var nodo = document.getElementById("em-cliente-config");
    try { etiquetas = nodo ? JSON.parse(nodo.textContent).etiquetas || [] : []; } catch (e) { etiquetas = []; }
    etiquetas = etiquetas.map(function (t) { return String(t).toLowerCase().trim(); });
    return etiquetas;
  }

  // Condición de cliente de Regios. Se entienden «todos», «con sesión» y «con alguna de estas
  // etiquetas» (los convenios, conv-…); cualquier otra no se pinta, aunque se cobre en el carro.
  function clienteElegible(eleg) {
    if (!eleg || !eleg.type || eleg.type === "ALL_CUSTOMERS") return true;
    if (eleg.type === "LOGGED_IN_CUSTOMERS") return !!document.getElementById("em-cliente-config");
    if (eleg.type === "SPECIFIC_CUSTOMER_TAGS") {
      var mias = etiquetasCliente();
      return (eleg.tagsToCheck || []).some(function (t) { return mias.indexOf(String(t).toLowerCase().trim()) > -1; });
    }
    return false;
  }

  function evaluar(nodo, prod) {
    if (!nodo) return null;
    if (nodo.type === "APPLY_DISCOUNT") return valor(nodo.value);
    if (nodo.type === "CHECK_IF") {
      var resultados = (nodo.conditions || []).map(function (c) {
        var ok;
        if (c.type === "PRODUCT_ELIGIBILITY") ok = elegible(c.eligibility, prod);
        else if (c.type === "CUSTOMER_ELIGIBILITY") ok = clienteElegible(c.eligibility);
        else return false; // condición que no se entiende
        return c.includeOrExclude === "EXCLUDE" ? !ok : ok;
      });
      var cumple = nodo.matchType === "AND"
        ? resultados.length > 0 && resultados.every(Boolean)
        : resultados.some(Boolean);
      return evaluar(cumple ? nodo.then : nodo.otherwise, prod);
    }
    return null;
  }

  function reglaPara(d, prod) {
    var c = d.config;
    var ahora = Date.now();
    if (c.isEnabled === false) return null;
    if (d.startDate && Date.parse(d.startDate) > ahora) return null;
    if (d.endDate && Date.parse(d.endDate) < ahora) return null;
    if (c.customerEligibility && !clienteElegible(c.customerEligibility)) return null;
    var minimo = c.minimumPurchaseRequirements;
    if (minimo && minimo.requirementType && minimo.requirementType !== "NONE") return null;
    if (c.productEligibility && !elegible(c.productEligibility, prod)) return null;
    var r = c.customLogic && c.customLogic.entryPoint
      ? evaluar(c.customLogic.entryPoint, prod)
      : valor(c.value);
    if (r) {
      r.hasta = d.endDate || null;
      // Oferta relámpago: el descuento dura un día o menos (inicio y término en Regios)
      r.relampago = !!(d.startDate && d.endDate) &&
        Date.parse(d.endDate) - Date.parse(d.startDate) <= RELAMPAGO_MAX;
      r.sobreReferencia = c.salePriceHandlingStrategy === "APPLY_TO_COMPARE_AT_PRICE";
    }
    return r;
  }

  /** Mejor descuento de Regios para un producto: { final, unaVez, hasta } o null (centavos). */
  function calcular(prod, precio, ref) {
    if (reglas === null) reglas = leerConfig();
    var mejor = null;
    reglas.forEach(function (d) {
      var r = reglaPara(d, prod);
      if (!r) return;
      var base = r.sobreReferencia && ref > precio ? ref : precio;
      var final = r.tipo === "porcentaje"
        ? Math.round(base * (1 - r.valor / 100))
        : r.tipo === "precio"
          ? r.valor * 100
          : base - r.valor * 100;
      final = Math.max(0, final);
      if (final >= precio) return;
      if (!mejor || final < mejor.final) mejor = { final: final, unaVez: r.unaVez, hasta: r.hasta, relampago: r.relampago };
    });
    return mejor;
  }

  function plata(centavos) {
    return "$" + Math.round(centavos / 100).toLocaleString("es-CL");
  }

  function producto(el) {
    return {
      id: String(el.dataset.regiosProducto || ""),
      variante: String(el.dataset.regiosVariante || ""),
      colecciones: String(el.dataset.regiosColecciones || "").split(",").filter(Boolean),
    };
  }

  function texto(el, valorNuevo) {
    if (el && el.textContent.trim() !== valorNuevo) el.textContent = valorNuevo;
  }

  function fechaCorta(iso) {
    var d = new Date(iso);
    return ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
  }

  function horaCorta(iso) {
    var d = new Date(iso);
    return ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
  }

  /**
   * Barra bajo el menú en la ficha de un producto con oferta de 24 horas: «solo por hoy» y la
   * cuenta atrás hasta el término del descuento de Regios. Sigue a la variante elegida: si la
   * nueva no tiene la oferta, la barra se quita. Va pegada bajo el menú (dentro del <header>, que
   * el tema superpone a la página), así queda debajo también cuando el menú va sobre el video.
   */
  var barra = null, relojBarra = null, empujado = null;
  // En las fichas con video el menú y la barra van sobre el video: el texto de la portada
  // (sections/landing-v3.liquid) baja el alto de la barra. En las demás el contenido empieza bajo
  // el menú: se baja la página entera.
  function empujarContenido(alto) {
    var main = document.querySelector("main");
    var menu = document.querySelector(".section-header header.header");
    if (!main || !menu) return;
    if (empujado) { empujado.el.style.paddingTop = empujado.antes; empujado.el.style.marginTop = empujado.margen; empujado = null; }
    if (!alto) return;
    var primero = main.firstElementChild;
    if (!primero) return;
    if (primero.getBoundingClientRect().top >= menu.getBoundingClientRect().bottom - 2) {
      empujado = { el: main, antes: main.style.paddingTop, margen: main.style.marginTop };
      main.style.marginTop = alto + "px";
      return;
    }
    var marco = primero.querySelector(".l3--portada .l3__marco");
    if (marco) {
      empujado = { el: marco, antes: marco.style.paddingTop, margen: marco.style.marginTop };
      marco.style.paddingTop = (parseFloat(getComputedStyle(marco).paddingTop) + alto) + "px";
    }
  }
  function barraRelampago(hasta) {
    var fin = hasta ? Date.parse(hasta) : NaN;
    if (isNaN(fin) || fin <= Date.now()) {
      if (barra) { barra.remove(); barra = null; clearInterval(relojBarra); empujarContenido(0); }
      return;
    }
    if (!barra) {
      // Pegada bajo el menú: el <header> del tema va superpuesto (position: absolute) sobre la página
      var cabecera = document.querySelector(".section-header header.header");
      if (!cabecera) return;
      barra = document.createElement("div");
      barra.className = "barra-24h";
      barra.setAttribute("role", "status");
      barra.innerHTML =
        '<div class="barra-24h__interior page-width">' +
          '<p class="barra-24h__texto">' +
            '<span class="barra-24h__cyber" hidden></span>' +
            '<span class="barra-24h__mensaje"><strong>Solo por hoy</strong><span class="barra-24h__largo">: este producto está en oferta por <span class="relampago__horas">24 horas</span></span></span>' +
          '</p>' +
          '<p class="barra-24h__cuenta"><span class="barra-24h__termina">Termina en</span> <span class="barra-24h__reloj" data-reloj>--:--:--</span></p>' +
        '</div>';
      var campBarra = campanaPara(null);
      if (campBarra) {
        var spanBarra = barra.querySelector(".barra-24h__cyber");
        spanBarra.textContent = campBarra.texto;
        spanBarra.hidden = false;
      }
      cabecera.appendChild(barra);
      empujarContenido(barra.offsetHeight);
    }
    clearInterval(relojBarra);
    var reloj = barra.querySelector("[data-reloj]");
    function tic() {
      var resta = Math.floor((fin - Date.now()) / 1000);
      if (resta <= 0) { barraRelampago(null); return; }
      var dos = function (n) { return (n < 10 ? "0" : "") + n; };
      reloj.textContent = dos(Math.floor(resta / 3600)) + ":" + dos(Math.floor((resta % 3600) / 60)) + ":" + dos(resta % 60);
    }
    tic();
    relojBarra = setInterval(tic, 1000);
  }

  function pintarPrecio(el) {
    if (el.dataset.regiosAplicado) return;
    var precio = +el.dataset.regiosPrecio;
    var ref = +el.dataset.regiosRef || 0;
    var r = calcular(producto(el), precio, ref);
    el.dataset.regiosAplicado = "1";
    // Precio principal de la ficha (no tarjetas de «también te puede gustar»): manda la barra de 24 horas
    if (!el.hasAttribute("data-regios-tarjeta") && el.closest(".product__info-container")) {
      barraRelampago(r && r.relampago ? r.hasta : null);
    }
    if (!r) return;
    el.dataset.regiosOferta = "1";
    var tachado = Math.max(ref, precio);
    var pct = Math.round(((tachado - r.final) / tachado) * 100);

    el.classList.add("price--on-sale");
    el.querySelectorAll(".price__regular .price-item--regular").forEach(function (x) { texto(x, plata(r.final)); });
    texto(el.querySelector(".price__sale s.price-item--regular"), plata(tachado));
    texto(el.querySelector(".price__sale .price-item--sale"), plata(r.final));

    if (el.hasAttribute("data-regios-tarjeta")) {
      var cont = el.querySelector(".price__container");
      if (cont) cont.classList.add("break");
      var fila = el.querySelector(".price__sale > .flex");
      if (fila && el.hasAttribute("data-regios-insignia") && !fila.querySelector(".price__badge")) {
        var b = document.createElement("span");
        b.className = "price__badge price__badge--in-card lh1 color-foreground";
        b.setAttribute("data-regios-js", "");
        b.textContent = "-" + pct + "%";
        fila.appendChild(b);
      }
    } else {
      if (el.hasAttribute("data-regios-insignia") && !el.querySelector(":scope > .price__badge")) {
        var badge = document.createElement("span");
        badge.className = "price__badge lh1 color-foreground";
        badge.textContent = "Ahorra " + pct + "%";
        el.appendChild(badge);
        var campFicha = campanaPara(producto(el));
        if (campFicha) {
          var cyber = document.createElement("span");
          cyber.className = "price__badge price__badge--campana lh1";
          el.appendChild(pintarCampana(cyber, campFicha));
        }
        if (r.relampago) el.appendChild(etiquetaRelampago("price__badge price__badge--relampago lh1"));
      }
      if (!el.querySelector(".price__campana")) {
        var nota = document.createElement("p");
        nota.className = "price__campana";
        nota.textContent = (r.relampago ? "Oferta solo por 24 horas" : "Descuento de campaña") +
          (r.hasta ? " · hasta el " + fechaCorta(r.hasta) + (r.relampago ? " a las " + horaCorta(r.hasta) : "") : "") +
          ". Se aplica solo en el carro.";
        el.appendChild(nota);
      }
    }
  }

  function pintarBurbuja(el) {
    if (el.dataset.regiosAplicado) return;
    el.dataset.regiosAplicado = "1";
    var precio = +el.dataset.regiosPrecio;
    var ref = +el.dataset.regiosRef || 0;
    var r = calcular(producto(el), precio, ref);
    if (!r) return;
    var tachado = Math.max(ref, precio);
    el.textContent = "Ahorra " + Math.round(((tachado - r.final) / tachado) * 100) + "%";
    el.hidden = false;
    var campTarjeta = campanaPara(producto(el));
    if (campTarjeta && el.parentElement && !el.parentElement.querySelector(".badge--campana")) {
      // La foto de la tarjeta mide 130-160 px: lado a lado, las dos etiquetas se pisan.
      // Van en una fila que ocupa el ancho de la foto: CYBER DAYS a la izquierda, «Ahorra X%» a la derecha.
      var pila = document.createElement("div");
      pila.className = "badges-pila";
      var cyber = document.createElement("span");
      cyber.className = "badge badge--campana font-body-bold";
      pintarCampana(cyber, campTarjeta);
      el.parentElement.insertBefore(pila, el);
      pila.appendChild(cyber);
      pila.appendChild(el);
    }
    // «Solo por 24 horas» va abajo de la foto, fuera de la pila
    var caja = el.closest(".badges-pila") ? el.closest(".badges-pila").parentElement : el.parentElement;
    if (r.relampago && caja && !caja.querySelector(".badge--relampago")) {
      // Si la tarjeta ya tiene etiquetas manuales abajo a la izquierda (snippets/etiquetas-producto.liquid), se suma a esa pila
      var pilaManual = caja.querySelector(".etiquetas-producto--tarjeta");
      if (pilaManual) pilaManual.appendChild(etiquetaRelampago("badge badge--relampago font-body-bold"));
      else caja.appendChild(etiquetaRelampago("badge badge--bottom-left badge--relampago badge--position-3 font-body-bold"));
    }
  }

  function pintarCuota(el) {
    if (el.dataset.regiosAplicado) return;
    el.dataset.regiosAplicado = "1";
    var precio = +el.dataset.regiosPrecio;
    var cuotas = +el.dataset.regiosCuota || 3;
    var r = calcular(producto(el), precio, 0);
    if (!r) return;
    texto(el, plata(Math.floor(r.final / cuotas)));
  }

  // Con un código manual en el carro, la función «Strikethrough for manual discount codes» de
  // Regios marca como en oferta precios a los que el código no aplica (rojo, tachado vacío).
  // Un precio solo queda en oferta si tiene precio de comparación o un descuento pintado aquí.
  function limpiar(el) {
    if (el.hasAttribute("data-regios-burbuja") || el.hasAttribute("data-regios-cuota")) return;
    if (el.dataset.regiosOferta) return;
    if ((+el.dataset.regiosRef || 0) > (+el.dataset.regiosPrecio || 0)) return;
    if (el.classList.contains("price--on-sale")) el.classList.remove("price--on-sale");
    if (el._regiosFoto) el._regiosFoto.clase = el.className;
  }

  /**
   * Guardia: un precio ya pintado no lo cambia nadie más. El bloque «Recommendations Discount»
   * de Regios, al entrar en pantalla, escribía el precio del primer producto recomendado (un
   * casco: $44.990 → $34.990, «Ahorra 22%») sobre todos los precios de la ficha, incluido el de
   * la bicicleta. Se guarda cómo quedó cada precio y, si otro script lo toca, se repone. Los
   * cambios legítimos del tema (cambio de variante) reemplazan el elemento entero y se vuelven a
   * pintar; el único que escribe encima es el selector de variante de los complementarios, que
   * se atiende en repintarComplementario.
   */
  function proteger(el) {
    limpiar(el);
    el._regiosFoto = { html: el.innerHTML, clase: el.className, oculto: el.hidden };
    if (el._regiosGuardia) return;
    el._regiosGuardia = new MutationObserver(function () {
      var f = el._regiosFoto;
      if (!f) return;
      if (el.innerHTML !== f.html) el.innerHTML = f.html;
      if (el.className !== f.clase) el.className = f.clase;
      if (el.hidden !== f.oculto) el.hidden = f.oculto;
    });
    el._regiosGuardia.observe(el, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ["class", "hidden"],
    });
  }

  // Cambio de variante en «Llévalo junto»: el tema escribe el precio base de la variante elegida
  // (assets/complementary-products.js). Se suelta la guardia antes de que escriba (fase de
  // captura) y luego se pinta de nuevo con la variante nueva y su descuento.
  function repintarComplementario(e) {
    var sel = e.target;
    if (!sel || !sel.closest || !sel.matches("select")) return;
    var item = sel.closest(".complementary__item");
    var el = item && item.querySelector("[data-regios-precio]");
    var opcion = sel.querySelector("option:checked");
    if (!el || !opcion || !opcion.dataset.price) return;
    el._regiosFoto = null;
    setTimeout(function () {
      el.querySelectorAll("[data-regios-js]").forEach(function (x) { x.remove(); });
      el.dataset.regiosPrecio = opcion.dataset.price;
      el.dataset.regiosRef = opcion.dataset.compareAtPrice || 0;
      el.dataset.regiosVariante = opcion.value;
      delete el.dataset.regiosOferta;
      delete el.dataset.regiosAplicado;
      pintar(item);
    }, 0);
  }

  function pintar(raiz) {
    raiz = raiz || document;
    raiz.querySelectorAll("[data-regios-precio]:not([data-regios-aplicado])").forEach(function (el) {
      if (el.hasAttribute("data-regios-burbuja")) pintarBurbuja(el);
      else if (el.hasAttribute("data-regios-cuota")) pintarCuota(el);
      else pintarPrecio(el);
      proteger(el);
    });
    // Total de «Llévalo junto»: con todo en 0 debe decir $0 (Regios le escribía el precio del casco)
    raiz.querySelectorAll(".complementary__total__price").forEach(function (el) {
      if (!el._regiosGuardia) proteger(el);
    });
  }

  // Lo que el tema escribe con product-price.update() (total y variantes de «Llévalo junto») es
  // legítimo: la foto se pone al día en el acto y la guardia no lo revierte.
  if (window.customElements) {
    customElements.whenDefined("product-price").then(function () {
      var proto = customElements.get("product-price").prototype;
      var original = proto.update;
      if (!original || original._regios) return;
      proto.update = function () {
        var salida = original.apply(this, arguments);
        if (this._regiosFoto) this._regiosFoto = { html: this.innerHTML, clase: this.className, oculto: this.hidden };
        return salida;
      };
      proto.update._regios = true;
    });
  }

  // Para assets/precio-total-cantidad.js (total por N unidades)
  window.RegiosPrecios = { calcular: calcular };

  function iniciar() {
    document.addEventListener("change", repintarComplementario, true);
    pintar();
    // Precios que el tema vuelve a dibujar (cambio de variante, filtros, compra rápida)
    document.querySelectorAll("[data-regios-precio]").forEach(limpiar);
    new MutationObserver(function (cambios) {
      var nuevos = false;
      for (var i = 0; i < cambios.length; i++) {
        var c = cambios[i];
        if (c.type === "attributes") {
          if (c.target.hasAttribute && c.target.hasAttribute("data-regios-precio")) limpiar(c.target);
        } else if (c.addedNodes.length) {
          nuevos = true;
        }
      }
      if (nuevos) {
        pintar();
        document.querySelectorAll("[data-regios-precio]").forEach(limpiar);
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
})();
